import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import MandatoryPasswordChange from "./MandatoryPasswordChange";

export default function ProtectedRoute({ children, masterOnly = false }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen grid place-items-center text-slate-500 text-sm">
        Loading…
      </div>
    );
  }
  if (user === null) return <Navigate to="/login" replace />;
  // Temp ex-employees only see /my-offboarding
  if (user.role === "ex_employee_temp") {
    const path = typeof window !== "undefined" ? window.location.pathname : "";
    if (path !== "/my-offboarding") return <Navigate to="/my-offboarding" replace />;
  }
  // Candidate temp users only see /my-onboarding
  if (user.role === "candidate_temp") {
    const path = typeof window !== "undefined" ? window.location.pathname : "";
    if (path !== "/my-onboarding") return <Navigate to="/my-onboarding" replace />;
  }
  if (masterOnly && user.role !== "master_admin") return <Navigate to="/" replace />;
  // SEC-001 — Hard-gate every protected route when the user is still on the
  // seeded / weak password. Layout-wrapped pages already render this dialog,
  // but custom routes that skip Layout (e.g. /my-onboarding, /my-offboarding)
  // would otherwise get stuck on a 423 "Password reset required" with no UI
  // to fix it. Rendering here covers ALL authenticated routes uniformly.
  return (
    <>
      {children}
      <MandatoryPasswordChange />
    </>
  );
}
